module.exports = __webpack_public_path__ + "img/DSC_0071.26f17ffc.jpg";